var _style, _g, _path, _path2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-229 31 500 500",
    style: {
      enableBackground: "new -229 31 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:url(#shape_3_1_);}\r\n\t.st2{fill:url(#XMLID_3_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shape_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape_4_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st0",
    d: "M-161.5,464.3l25.8-94.1c-15.9-27.6-24.3-58.8-24.3-90.9c0-100.2,81.6-181.7,181.7-181.7 c48.6,0,94.2,18.9,128.6,53.3c34.3,34.3,53.2,80,53.2,128.5c0,100.2-81.6,181.7-181.7,181.7l0,0h-0.1 c-30.4,0-60.3-7.6-86.8-22.1L-161.5,464.3z M-60.7,406.2l5.5,3.3c23.2,13.8,49.8,21,76.9,21.1h0.1c83.3,0,151-67.7,151-151 c0-40.4-15.7-78.3-44.2-106.8s-66.4-44.3-106.8-44.3c-83.3,0-151.1,67.7-151.1,151c0,28.5,8,56.3,23.1,80.4l3.6,5.7l-15.3,55.7 L-60.7,406.2z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shape_3_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.9502,
    y1: 106,
    x2: 20.9502,
    y2: 460,
    gradientTransform: "matrix(1 0 0 -1 0 564)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20B038"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#60D66A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shape_3",
    className: "st1",
    d: "M-155.2,458l24.9-90.9c-15.4-26.6-23.4-56.8-23.4-87.7C-153.7,182.7-75,104,21.7,104 c46.9,0,91,18.3,124.1,51.4c33.1,33.2,51.4,77.2,51.3,124.1c0,96.7-78.7,175.4-175.4,175.4l0,0h-0.1c-29.4,0-58.2-7.4-83.8-21.3 L-155.2,458z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape_2_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 21,
    y1: 99.7,
    x2: 21,
    y2: 466.4,
    gradientTransform: "matrix(1 0 0 -1 0 564)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9F9F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st2",
    d: "M-161.5,464.3l25.8-94.1c-15.9-27.6-24.3-58.8-24.3-90.9c0-100.2,81.6-181.7,181.7-181.7 c48.6,0,94.2,18.9,128.6,53.3c34.3,34.3,53.2,80,53.2,128.5c0,100.2-81.6,181.7-181.7,181.7l0,0h-0.1 c-30.4,0-60.3-7.6-86.8-22.1L-161.5,464.3z M-60.7,406.2l5.5,3.3c23.2,13.8,49.8,21,76.9,21.1h0.1c83.3,0,151-67.7,151-151 c0-40.4-15.7-78.3-44.2-106.8s-66.4-44.3-106.8-44.3c-83.3,0-151.1,67.7-151.1,151c0,28.5,8,56.3,23.1,80.4l3.6,5.7l-15.3,55.7 L-60.7,406.2z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "shape_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape_1_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_10_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st0",
    d: "M-23.7,203.4c-3.4-7.6-7-7.7-10.2-7.8c-2.6-0.1-5.7-0.1-8.7-0.1s-7.9,1.1-12.1,5.7 c-4.2,4.5-15.9,15.5-15.9,37.9c0,22.3,16.3,43.9,18.5,47c2.3,3,31.4,50.3,77.6,68.5C63.9,369.7,71.7,366.7,80,366 c8.3-0.8,26.9-11,30.7-21.6c3.8-10.6,3.8-19.7,2.6-21.6c-1.1-1.9-4.2-3-8.7-5.3s-26.9-13.3-31-14.8c-4.2-1.5-7.2-2.3-10.2,2.3 c-3,4.5-11.7,14.8-14.4,17.8c-2.6,3-5.3,3.4-9.8,1.1S20,316.8,2.7,301.4c-13.5-12-22.6-26.9-25.3-31.4c-2.6-4.5-0.3-7,2-9.3 c2-2,4.5-5.3,6.8-8s3-4.5,4.5-7.6c1.5-3,0.8-5.7-0.4-8C-10.8,234.8-19.6,212.4-23.7,203.4z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.8be1cb193cdd1d8b4a0b053d05f4c410.svg";
export { ForwardRef as ReactComponent };